import { ManualNotificationsItemInput, ManualNotificationType } from 'api';

export const MAX_MESSAGE_LENGTH = 140;

export const CREATE_MESSAGE_VALUES: ManualNotificationsItemInput = {
  notification_type: ManualNotificationType.Now,
  send_at: null,
  segment_ids: [],
  message: {
    body: '',
    url: '',
  },
  email: null,
  entire_company: true,
};
